import React from "react";
import PropTypes from 'prop-types';

export const SDS_VERSION_EDITABLE = "sdsVersionEditable";
export const SUBSTANCE_INVENTORY_VISIBLE = "substanceInventoryVisible";
export const SUBSTANCE_ADR_VISIBLE = "substanceAdrVisible";
export const SDS_EXPORT_ENABLED = "sdsExportEnabled";
export const VERISK_INTEGRATION_ENABLED = "veriskIntegrationEnabled";
export const MULTIPLE_DEPARTMENT_PER_USER = "multipleDepartmentPerUser";
export const MACHINERY_CRUD_ENABLED = "machineryCrudEnabled";
export const EVALUATION_DESCRIPTION_VISIBLE = "evaluationDescriptionVisible";
export const R_PHRASES_AND_SCORE_P_VISIBLE = "rphrasesAndScorepVisible";
export const AUTH_TIMEOUT_ENABLED = "authTimeoutEnabled";
export const FULL_SDS_EVALUATION_ENABLED = "fullSdsEvaluationEnabled";
export const SDS_DELETION_ENABLED = "sdsDeletionEnabled";

export const ShowBasedOnConfig = (props, context) => {
  const {children, configKey, enabledOn = true, ...other} = props;
  if (context.config[configKey] !== enabledOn) {
    return null;
  }

  return React.cloneElement(React.Children.only(children), {
    ...other,
  });
}

ShowBasedOnConfig.contextTypes = {
  config: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/main/components/container/ShowBasedOnConfig.js